<div class="video-component">
  <video
    #video
    (canplaythrough)="handleCanPlay()"
    (insideViewport)="handleViewportChange($event)"
    [class.cover]="cover()"
    [id]="idVideo"
    [poster]="posterLink() | mediaUrl: posterStyle()"
    [preload]="autoplay() ? 'auto' : 'metadata'"
    class="video"
    playsinline>
    @if (effectiveWebmUrl()) {
      <source [src]="effectiveWebmUrl()" type="video/webm" />
    }
    @if (effectiveMp4Url()) {
      <source [src]="effectiveMp4Url()" type="video/mp4" />
    }
  </video>
  <div [ngStyle]="controlsStyle()" class="controls">
    @if (isPlayButtonDisplayed() && iconPlaySize() && !autoplay()) {
      <div (click)="onPlay()" class="play-button">
        <i
          [color]="'WHITE'"
          [iconName]="'PLAY_CIRCLE'"
          [ngStyle]="{ 'min-width': '4.8rem', 'min-height': '4.8rem' }"
          [refresh]="true"
          [size]="iconPlaySize()"></i>
      </div>
    }
    @if (!isPlayButtonDisplayed()) {
      <div (click)="onPause()" [ngStyle]="buttonPauseStyle()" class="pause-button">
        <i [color]="'WHITE'" [iconName]="'PAUSE_CIRCLE'" [size]="iconPauseSize()"></i>
      </div>
    }
    @if (isSoundOnOffDisplayed()) {
      @if (isSoundOn()) {
        <div (click)="onToggleSound()" [ngStyle]="buttonSoundStyle()" class="mute-button">
          <i [color]="'WHITE'" [iconName]="'SOUND_ON'" [size]="iconSoundSize()"></i>
        </div>
      } @else {
        <div (click)="onToggleSound()" [ngStyle]="buttonSoundStyle()" class="mute-button">
          <i [color]="'WHITE'" [iconName]="'SOUND_OFF'" [size]="iconSoundSize()"></i>
        </div>
      }
    }
  </div>
</div>
